import React, {useEffect, useMemo, useState} from "react";
import TopBreadcrumbs from "../Settings/Surcharge/TopBreadcrumbs";
import {addCompanyBreadcrumb, networkIntegrationBreadcrumb, SubscriptionBreadcrumb} from "../../common/data/parties";
import {Card, CardBody, Container, Row} from "reactstrap";
import SimpleBar from "simplebar-react";
import {CommonValue} from "../Parties/PartiesCol";
import {Edit} from "../Settings/SettingsCol";
import TfBreadcrumbs from "../../components/Common/TfBreadcrumbs";
import SubscriptionsTable from "../Subscriptions/components/SubscriptionsTable";
import {useNavigate} from "react-router-dom";
import IntegrationSummaryTable from "./IntegrationSummaryTable";
import {useDispatch, useSelector} from "react-redux";
import {GET_NETWORK_INTEGRATION_SUMMARY} from "../../store/Settings/actiontype";

const NetworkIntegrationsSummary = () => {
    const dispatch = useDispatch();
    const [value, setValue] = useState('');
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(0);
    const { integrationSummary } = useSelector((state) => state?.settings);

    useEffect(() => {
        dispatch({ type: GET_NETWORK_INTEGRATION_SUMMARY })
    }, []);

    const editHandler = (data) => {
        console.log(data);
        navigate(`/network/edit/integration`, {
            state: {
                id: data.id || '',
                data: data
            },
        });
    }

    const viewPopupHandler = (data) => {

    }

    const integrationsColumns = useMemo(
        () => [
            {
                Header: "Integrations Id",
                accessor: "id",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "App Type",
                accessor: "appType",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "App Name",
                accessor: "appName",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "Action",
                accessor: "action",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <div className="d-flex justify-content-start align-items-start h-100">
                            <p style={{marginTop: "15px"}}>
                                <Edit cellProps={cellProps} viewPopupHandler={editHandler} />
                            </p>
                        </div>
                    );
                },
            }
        ], []);
//
    return(
        <>
            <div className="page-content settings_users_wrapper">
                <Container fluid>
                    <div className="main_freight_wrapper">
                        <div className="tf_top_breadcrumb_rate_wrap">
                            <TfBreadcrumbs breadcrumb={networkIntegrationBreadcrumb}/>
                        </div>
                        <div className="freight_filter_wrap d-flex align-items-center">
                            <p className="label flex-grow-1 m-0">Filters :</p>
                            <div className="right_actions_wrap flex-shrink-0 d-flex align-items-center">
                                <div className="search_form">
                                    <form>
                                        <div className="position-relative">
                                            <input
                                                type="search"
                                                onChange={e => {
                                                    e.preventDefault();
                                                    setValue(e.target.value);
                                                    onChange(e.target.value);
                                                    return false;
                                                }}
                                                className="form-control"
                                                placeholder="Search"
                                                value={value || ""}
                                            />
                                            <button className="btn" type="button">
                                                <i className="bx bx-search-alt-2 align-middle"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className="add_btn">
                                    <button className='border-0' onClick={() => {
                                        navigate(`/network/create/integration`);
                                    }}>
                                        <i className='bx bx-plus align-middle'></i> Add Integrations
                                    </button>
                                </div>
                            </div>
                        </div>
                        <IntegrationSummaryTable
                            columns={integrationsColumns}
                            data={integrationSummary?.content || []}
                            customPageSize={10}
                            component={"IntegrationSummary"}
                            loader={false}
                            setCurrentPage={setCurrentPage}
                            totalPages={0}
                            totalEntries={0} />
                    </div>
                </Container>
            </div>
        </>
    )
}

export default NetworkIntegrationsSummary;
